import type { PayloadAction } from "@reduxjs/toolkit";
import { DUMMY_GROUP_AUTHORITY } from "Data/Dummy/User";
import { createAppSlice } from "Data/Redux/Store";
import type { GroupAuthorityState } from "Interfaces";

const initialState = DUMMY_GROUP_AUTHORITY;

// #region Reducers

export const setGroupAuthorityReducer = (state: GroupAuthorityState, action: PayloadAction<GroupAuthorityState>) => {
	return action.payload;
};

// #endregion

// #region Selectors

export const getGroupAuthority = (state: GroupAuthorityState) => {
	return state;
};

// #endregion

const authoritySlice = createAppSlice({
	name: "authority",
	initialState,
	reducers: {
		setGroupAuthorityAction: setGroupAuthorityReducer
	},
	selectors: {
		selectGroupAuthority: getGroupAuthority
	}
});

export default authoritySlice;

export const {
	setGroupAuthorityAction
} = authoritySlice.actions;

export const { selectGroupAuthority } = authoritySlice.selectors;
